export function formatDate(value?: string | null): string {
  if (!value) return '—';

  const datePart = value.split(/[T ]/)[0]; // strip any time component
  const parts = datePart.split(/[-/]/).map(p => p.trim());
  if (parts.length !== 3) return value;

  let yyyy: string, mm: string, dd: string;

  if (parts[0].length === 4) {
    // YYYY-MM-DD
    [yyyy, mm, dd] = parts;
  } else {
    // DD-MM-YYYY or MM-DD-YYYY — disambiguate only when possible
    const [a, b, y] = parts;
    yyyy = y;
    [mm, dd] = Number(a) > 12 ? [b, a] : [a, b]; // if first > 12, it must be the day
  }

  return `${mm.padStart(2, '0')}-${dd.padStart(2, '0')}-${yyyy}`;
}